function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.57537 19.2176C1.67013 15.3123 1.67013 8.98066 5.57537 5.07542C9.48061 1.17017 15.8123 1.17017 19.7175 5.07542L20.4246 5.78252L14.0607 12.1465L20.4246 18.5104L19.0104 19.9246L12.6464 13.5607L6.28248 19.9247L5.57537 19.2176ZM6.32624 17.0525C4.49396 14.6981 4.16063 11.5552 5.32625 8.91394C5.44142 9.42758 5.59747 9.94733 5.78607 10.4593C6.3474 11.9829 7.2451 13.5719 8.43042 14.9483L6.32624 17.0525ZM10.9592 5.28613C10.4473 5.09752 9.92753 4.94147 9.41388 4.82631C12.0551 3.66067 15.1981 3.994 17.5524 5.82629L15.4482 7.93047C14.0718 6.74515 12.4828 5.84745 10.9592 5.28613ZM10.2678 7.16281C11.542 7.63227 12.8734 8.37867 14.0294 9.34928L9.84923 13.5295C8.87862 12.3735 8.13222 11.0421 7.66276 9.76785C7.19406 8.49567 7.0414 7.39401 7.12332 6.62337C7.89396 6.54146 8.99561 6.69411 10.2678 7.16281Z",
  fill: "black"
});

var SvgIcCategoryParasol = function SvgIcCategoryParasol(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCategoryParasol, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_category_parasol.244c1283.svg";
export { ForwardRef as ReactComponent };